import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ChangeDetectionStrategy } from '@angular/core';
import { QuickLink } from '../../shared/models/quick-links';
import {PENDO_MAPPINGS} from "../../shared/pendo/pendo-mappings";

@Component({
  selector: 'tess-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss'],
  imports: [CommonModule],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickLinksComponent {
  @Input({ required: true }) links: QuickLink[] = [];
  pendoMappings = PENDO_MAPPINGS;
}
